import { useNavigate } from '@tanstack/react-router';
import { Subtabs } from '@/components/Subtabs';
import { useModuleAccess } from '@/lib/permissions';
import { POSTA_TAB_LABEL, type PostaTab } from './helpers';

type Tab = PostaTab | 'sprava';

export function PostaSubtabs({ active, count, onListChange }: {
  active: Tab;
  count?: number;
  onListChange?: (tab: PostaTab) => void;
}) {
  const navigate = useNavigate();
  const { can, resolved } = useModuleAccess();
  const items: Array<{ value: Tab; label: string; count?: number }> =
    (Object.entries(POSTA_TAB_LABEL) as Array<[PostaTab, string]>).map(([value, label]) => ({
      value, label, ...(value === active && count !== undefined ? { count } : {}),
    }));
  if (resolved && can('posta', 'admin')) items.push({ value: 'sprava', label: 'Správa' });
  return (
    <Subtabs<Tab>
      aria-label="Pošta"
      items={items}
      value={active}
      onChange={(next) => {
        if (next === 'sprava') navigate({ to: '/posta/sprava' });
        else if (onListChange) onListChange(next);
        else navigate({ to: '/posta', search: { tab: next === 'odeslana' ? undefined : next } });
      }}
    />
  );
}
